import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initGA, updateConsentMode } from "./utils/analytics";
import { GA_TRACKING_ID } from "./ga";

const queryClient = new QueryClient();

initGA(GA_TRACKING_ID);

// Listen for Cookiebot consent changes
if (typeof window !== "undefined") {
  // Wait for Cookiebot to load and update consent
  const handleConsentUpdate = () => {
    // Small delay to ensure Cookiebot.consent object is ready
    setTimeout(() => {
      if (window.gtag) {
        updateConsentMode();
      }
    }, 100);
  };

  window.addEventListener("CookiebotOnAccept", handleConsentUpdate);
  window.addEventListener("CookiebotOnDecline", handleConsentUpdate);

  window.addEventListener("CookiebotOnDialogInit", () => {
    // Cookiebot dialog initialized, update consent if GA is already loaded
    handleConsentUpdate();
  });

  // This is the most important event - fires when consent is ready
  window.addEventListener("CookiebotOnConsentReady", handleConsentUpdate);

  // Also listen for when user changes consent
  window.addEventListener("CookiebotOnConsentChange", handleConsentUpdate);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
